module.exports = __webpack_public_path__ + "static/media/logo.33a404c4.png";